import React, { useState } from 'react'
import dateFnsFormat from 'date-fns/format';
import dateFnsParse from 'date-fns/parse';
import compareAsc from 'date-fns/compareAsc';
import parseISO from 'date-fns/parseISO';
import SummaryRoom from './SummaryRoom.js'
import ReactModal from 'react-modal';
import ChangeOccupants from '../ChangeOccupants'

export default function Summary (props){

    var toPay = payNow(props.reservation.selectedRooms);
    
    function payNow(selectedRooms) {
        //console.log('Selected Room: ' + selectedRooms[0].totalPrice)
        //console.log('Selected RoomPrice Price: ' + selectedRooms[0].roomPrice.promoCodePrice)
        //console.log('Payment Schedule ' + selectedRooms[0].roomPrice.paymentSchedule[0].due)
        var total = 0;

        if (props.reservation.selectedRooms[0].roomPrice.withinGracePeriod) {
            for (var i = 0; i < selectedRooms.length; i++) {
                for (var j = 0; j < selectedRooms[i].roomPrice.paymentSchedule.length; j++) {
                    //console.log('PayNow compare = ' + compareAsc(parseISO(selectedRooms[i].roomPrice.paymentSchedule[j].due), new Date()))
                    //console.log('Amount = ' + selectedRooms[i].roomPrice.paymentSchedule[j].amount)
                    if (compareAsc(parseISO(selectedRooms[i].roomPrice.paymentSchedule[j].due), new Date()) < 1) {
                        total += selectedRooms[i].roomPrice.paymentSchedule[j].amount;
                    }
                }

            }
        }
        else {
            total = props.reservation.totalPrice;
        }
                
        return total;
    }

    const changeDates = () => {
        //warn will reset rooms

        props.changeDates();
    }

    return(

        <div className='summary-container'>
                
            <div className={'summary-dates'}>
                <div className='row'>
                    <div className='col-4'><small>Checkin:</small></div>
                    <div className='col-8 text-right'><small>{dateFnsFormat(dateFnsParse(props.reservation.checkIn, 'yyyy-MM-dd', new Date()), 'eee d MMM yyyy')}</small></div>
                </div>
                <div className='row'>
                    <div className='col-4'><small>Checkout:</small></div>
                    <div className='col-8 text-right'><small>{dateFnsFormat(dateFnsParse(props.reservation.checkOut, 'yyyy-MM-dd', new Date()), 'eee d MMM yyyy')}</small></div>

                </div>
                    
                <div className='row'>
                    <div className='col-6' ><small><a href="" onClick={(e) => { e.preventDefault(); if (window.confirm('If you change your arrival or departure date you will need to re-select your rooms based on availabilty.')) changeDates();  }} >Change Dates</a></small></div>
                    <div className='col-6 text-right'><small>{props.reservation.nights} nights stay</small></div>
                        
                </div>
                    
                    
                <hr/>
            </div>

            <div className='summary-room-details'>
                <SummaryRoomDetails
                    reservationPropertyKey={props.reservation.propertyKey}
                    propertyKey={props.propertyKey}
                    roomTypes={props.roomTypes}
                    selectedRooms={props.reservation.selectedRooms}
                    removeRoom={props.removeRoom}
                    changeRoom={props.changeRoom}
                    addRoom={props.addRoom}
                    changeAdults={props.changeAdults}
                    changeChildren={props.changeChildren}
                />
            </div>

            <div>

                <div className='row'>
                    <div className='col-6'><strong>Total</strong></div>
                    <div className='col-6 text-right'><strong>£{(props.reservation.totalPrice).toFixed(2)}</strong></div>
                </div>
                <div className='row'>
                    <div className='col-6'><strong>Pay Now</strong></div>
                    <div className='col-6 text-right'><strong>£{(toPay).toFixed(2)}</strong></div>
                </div>
                <div>
                    {toPay > 0 && 'Payment will be taken immediately.'
                    }
                </div>
                <div>
                    {toPay === 0 && '' //show payment schedule here
                    }
                </div>
            </div>
        </div>
        )
}

function SummaryRoomDetails(props) {

    const [showModal, setShowModal] = useState(false);

    const modalStyle = () => ({
        overlay: {
            display: 'inline-block',
            position: 'fixed',
            overflow: 'hidden',
            //height: '100%'
            //top: 0,
            //left: 0,
            //right: 0,
            //bottom: 0,
            //backgroundColor: 'rgba(255, 255, 255, 0.75)'
        },
        content: {
            display: 'block',
            verticalAlign: 'middle',
            //position: window.innerwidth > 600 ? 'relative' : 'fixed',
            top: window.innerWidth > 300 ? '128px' : '10px',
            //bottom: window.innerWidth > 300 ? 'none' : '10px',
            //left: window.innerWidth > 600 ? 'none' : '0px',
            //right: window.innerWidth > 600 ? 'none' : '0px',
            width: window.innerWidth > 300 ? '340px' : '340px',
            height: '243px',
            //border: '1px solid #ccc',
            background: '#fff',
            overflow: isTouchDevice() ? 'auto' : 'auto',
            WebkitOverflowScrolling: 'touch',
            //borderRadius: '4px',
            outline: 'none',
            padding: '6px',
            marginLeft: 'auto',
            marginRight: 'auto',
        }
    })

    const maxCapacityRoomType = props.roomTypes.sort((a, b) => {
        return b.maxCapacity - a.maxCapacity;
    })[0];

    
    function isTouchDevice() {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
    }

    function changeAdults(adults) {
        return;
    }

    function changeChildren(children) {
        return;
    }

    function closeChangeOccupants(adults, children) {
        setShowModal(false);
        props.addRoom(adults, children);
        
    }

    function close(){
        setShowModal(false);
    }

    function callAlert() {
        alert("You have chosen a holiday apartment which is not part of our main guest house. If you wish to reserve more rooms please confirm the reservation for the apartment first and then create a new reservation for the guest house.");

    }

    function showViewTermsLink(room) {

        let index = props.selectedRooms.findIndex(r => {
            if (r.roomTypeId === room.roomTypeId) {
                return true;
            }
        })

        return (
            !hasSingleCancellationPolicy
            ||
            !hasSingleDepositPolicy
            ||
            index === props.selectedRooms.length-1);  //is the last room in the list the return true

    }

    const hasSingleCancellationPolicy = props.selectedRooms.filter(x => x.roomPrice.cancellationPolicy.id === props.selectedRooms[0].roomPrice.cancellationPolicy.id).length === props.selectedRooms.length;
    
    const hasSingleDepositPolicy = props.selectedRooms.filter(x => x.roomPrice.depositPolicy.id === props.selectedRooms[0].roomPrice.depositPolicy.id).length === props.selectedRooms.length;

    return (
        <div>
            <div>
            {
                [...props.selectedRooms].map((selectedRoom, index) =>
                    <SummaryRoom
                        //index={index}
                        key={selectedRoom.roomTypeName}
                        selectedRoom={selectedRoom}
                        //roomTypeName={selectedRoom.roomTypeName}
                        //ratePlanName={selectedRoom.ratePlanName}
                        //adults={selectedRoom.adults}
                        changeAdults={props.changeAdults}
                        //children={selectedRoom.children}
                        changeChildren={props.changeChildren}
                        //price={selectedRoom.totalPrice}
                        //promoCode={selectedRoom.roomPrice.promoCode}
                        removeRoom={props.removeRoom}
                        changeRoom={props.changeRoom}
                        showViewTermsLink={showViewTermsLink(selectedRoom)}
                        //imageUrl={selectedRoom.imageUrl}      
                    />)
                }
            </div>
            <div className='text-right'>
                <small><a href="" onClick={(e) => { e.preventDefault(); props.reservationPropertyKey !== props.propertyKey? callAlert(): setShowModal(true); }} >Add another room</a></small>
            </div >
            <ReactModal
                isOpen={showModal}
                contentLabel="Minimal Modal Example"
                style={modalStyle()}
            >

            <ChangeOccupants
                //roomTypeName={props.selectedRoom.roomType.name}
                roomType={maxCapacityRoomType}
                adults={2}
                changeAdults={(dummyRoomType, adults) => changeAdults(adults)}
                children={0}
                changeChildren={(dummyRoomType, children) => changeChildren(children)}
                apply={(adults, children) => closeChangeOccupants(adults, children)}
                close={() => close() }
            />

            </ReactModal>
        </div>
        );

}


